import React from 'react';
import PropTypes from 'prop-types';

const FiletypeOtherPath = ({ fill = '#A3B1BF' }) => {
  return (
    <path
      fill={fill}
      d="M20.057 4.654c-.378-.361-1.1-.654-1.64-.654H7.702C6.763 4 6 4.728 6 5.626v20.748C6 27.272 6.762 28 7.7 28h16.6c.937 0 1.7-.728 1.7-1.626V11.29c0-.527-.302-1.243-.684-1.609l-5.259-5.027z"
    />
  );
};

FiletypeOtherPath.propTypes = {
  fill: PropTypes.string,
};

export default FiletypeOtherPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/filetype/filetype-other.jsx